import React from 'react';
import { StyledCustomCashItemTile, InnerBox } from './CustomCashItemTile.styles';
import { ReactComponent as CatalogCashAdd } from '@assets/icons/catalog-cash-add.svg';
import { Box, TextV2 } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';

interface CustomCashItemTileProps
  extends Readonly<{
    fundType: string;
    onClick: () => void;
  }> {}

export const CustomCashItemTile: React.FC<CustomCashItemTileProps> = ({ fundType, onClick }) => {
  const { t } = useTranslation('catalogRegistry');

  const translations = t('cashFundCatalog');
  return (
    <Box position="relative">
      <StyledCustomCashItemTile onClick={onClick}>
        <InnerBox>
          <CatalogCashAdd />
        </InnerBox>
      </StyledCustomCashItemTile>
      <TextV2 component="span" typographyVariant={['hed1', null, null, 'hed2']} textAlign="center">
        {translations.createYourOwn({ fund: fundType })}
      </TextV2>
    </Box>
  );
};
